import { requestStatusTypes } from "./requestStatusTypes";

export const requestApprovalStatusOptions = [
  {
    label: "Đang đợi duyệt",
    value: requestStatusTypes.submitted,
  },
  {
    label: "Đang đợi duyệt",
    value: requestStatusTypes.preApproved,
  },
  {
    label: "Đã duyệt",
    value: requestStatusTypes.approved,
  },
  {
    label: "Đang thực hiện",
    value: requestStatusTypes.inProgress, // isDemand === false
  },
  {
    label: "Đang tiếp nhận",
    value: requestStatusTypes.inProgressDemand, // isDemand === true
  },
  {
    label: "Tiến hành nghiệm thu",
    value: requestStatusTypes.acceptance, // isDemand === false
  },
  {
    label: "Đã tiếp nhận",
    value: requestStatusTypes.acceptanceDemand, // isDemand === true
  },
  {
    label: "Đã hoàn tất",
    value: requestStatusTypes.completed, // isDemand === false
  },
  {
    label: "Tiến hành thực hiện",
    value: requestStatusTypes.completedDemand, // isDemand === true
  },
  {
    label: "Đã bị từ chối",
    value: requestStatusTypes.rejected,
  },
];
